import { CardList } from "../../views/card/main";
import { CardProduct } from "../../views/card/product";
import { CardRecord } from "../../views/card/record";
import { CardTransaction } from "../../views/card/transaction";
import { CardHolder } from "../../views/card/holder";

import { langPage } from "../../locales";
import { CardApply } from "../../views/card/apply";
import { CardTransfer } from "../../views/card/transfer";

const lang = langPage?.card;

export const cardRouters = [
    {
        path: "/card/cardMain",
        name: "cardMain",
        exact: true,
        component: CardList,
        meta: {
            breadcrumb: [
                {
                    name: lang?.name,
                    path: ""
                },
                {
                    name: lang?.name,
                    path: ""
                }
            ],
            privilegeCode: "cardMain",
        }
    },
    {
        path: "/card/product",
        name: "product",
        exact: true,
        component: CardProduct,
        meta: {
            breadcrumb: [
                {
                    name: lang?.name,
                    path: ""
                },
                {
                    name: lang?.product.name,
                    path: ""
                }
            ],
            privilegeCode: "product",
        }
    },
    {
        path: "/card/cardRecord",
        name: "cardRecord",
        exact: true,
        component: CardRecord,
        meta: {
            breadcrumb: [
                {
                    name: lang?.name,
                    path: ""
                },
                {
                    name: lang?.record.fullName,
                    path: ""
                }
            ],
            privilegeCode: "cardRecord",
        }
    },
    {
        path: "/card/cardTransaction",
        name: "cardTransaction",
        exact: true,
        component: CardTransaction,
        meta: {
            breadcrumb: [
                {
                    name: lang?.name,
                    path: ""
                },
                {
                    name: lang?.transaction.name,
                    path: ""
                }
            ],
            privilegeCode: "cardTransaction",
        }
    },
    {
        path: "/card/holder",
        name: "holder",
        exact: true,
        component: CardHolder,
        meta: {
            breadcrumb: [
                {
                    name: lang?.name,
                    path: ""
                },
                {
                    name: '持卡人列表',
                    path: ""
                }
            ],
            privilegeCode: "holder",
        }
    },
    {
        path: "/card/apply",
        name: "apply",
        exact: true,
        component: CardApply,
        meta: {
            breadcrumb: [
                {
                    name: lang?.name,
                    path: ""
                },
                {
                    name: '实体卡申请列表',
                    path: ""
                }
            ],
            privilegeCode: "apply",
        }
    },
    {
        path: "/card/transfer",
        name: "transfer",
        exact: true,
        component: CardTransfer,
        meta: {
            breadcrumb: [
                {
                    name: lang?.name,
                    path: ""
                },
                {
                    name: '卡卡转账列表',
                    path: ""
                }
            ],
            privilegeCode: "transfer",
        }
    }, 
];
